module.exports = __webpack_public_path__ + "teqbahn-assets/media/IoT.497daf75.jpg";